module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BO-77126871ae17c4fad5be6a8a9280dfcf.png";